import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { withFormlyBootstrap } from '@ngx-formly/bootstrap';
import { provideFormlyCore } from '@ngx-formly/core';
import { mssFormlyConfig } from './formly.config';

/**
 * Root Formly providers for the shared custom field and wrapper configuration.
 */
export function provideMssFormly(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideFormlyCore([
      ...withFormlyBootstrap(),
      mssFormlyConfig,
    ]),
  ]);
}
